import React from "react";

export const CheckoutSuccess = props => {
  console.log("Checkout props", props);
  return <p>{JSON.stringify(props, null, 2)}</p>;
};
